import ListItem from "../../../components/ListItem";
import React from "react";

const ReservationListItem = (props) => {
    return (
        <>
            <ListItem
                key={props._key}
                _key={props._key}
                listStyle={props.listStyle}
                id={props.id}
                overwriteClasses={props.overwriteClasses}
                elements={props.elements}
                menu={props.menu}
                extra={false}
                setCheckoutReservation={props.setCheckoutReservation}
                setCheckoutCheckin={props.setCheckoutCheckin}
                dispatch={props.dispatch}
                hasValidCheckin={props.hasValidCheckin}
                setFilter={props.setFilter}
                filter={props.filter}
                setNKey={props.setNKey}
                sort={props.sort}
                setSort={props.setSort}
                info={props.info}
            />
        </>
    )
}

export default ReservationListItem